import React from "react";
import Popup from "reactjs-popup";
import DashboardRegulatedScatter from "./DashboardRegulatedScatter";
import "./DashboardRegulatedPopup.scss";

export default function DashboardRegulatedPopup({ data }) {
  return (
    <Popup
      modal
      nested
      className="dashboard-regulated-popup"
      trigger={
        <span className="dr-expand-icon" title="Expand">
          ⤢
        </span>
      }
    >
      {(close) => (
        <div className="dashboard-regulated-expanded">
          <div className="dr-expanded-header">
            <span>Regulated Data</span>
            <span className="close" onClick={close}>✕</span>
          </div>

          <span className="dr-expanded-divider" />

          <DashboardRegulatedScatter
            data={data}
            expanded={true}
          />
        </div>
      )}
    </Popup>
  );
}
